var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 76,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 44,
    x: 8,
    y: 16,
    fill: "#fff",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.496 23.5H39.5l8 8v19.002a1.999 1.999 0 0 1-2 1.998h-20a2 2 0 0 1-2-2v-25c0-1.105.891-2 1.996-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC3D00",
    d: "m39.5 23.5.354-.354A.5.5 0 0 0 39.5 23v.5Zm0 8H39a.5.5 0 0 0 .5.5v-.5Zm8 0h.5v-.207l-.146-.147-.354.354ZM25.496 24H39.5v-1H25.496v1ZM39 23.5v8h1v-8h-1Zm.5 8.5h8v-1h-8v1Zm-.354-8.146 8 8 .708-.708-8-8-.708.708ZM47 31.5v19.002h1V31.5h-1Zm-23 19v-25h-1v25h1Zm1.5 2.5h20v-1h-20v1ZM47 50.502C47 51.33 46.329 52 45.5 52v1c1.38 0 2.5-1.117 2.5-2.498h-1ZM23 50.5a2.5 2.5 0 0 0 2.5 2.5v-1a1.5 1.5 0 0 1-1.5-1.5h-1ZM25.496 23A2.496 2.496 0 0 0 23 25.5h1c0-.83.669-1.5 1.496-1.5v-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE5",
    stroke: "#CC3D00",
    strokeLinejoin: "round",
    d: "M39.5 31.5v-8l8 8h-8Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.90b68df6fa9cdb12189336cd5c4ed121.svg";
export { ForwardRef as ReactComponent };